// @ts-nocheck

import CommonApi from '../commonApi';
import { convertFromKopToRub, convertFromRubToKop } from '../pure/unitConversions';
import { downloadRequestWithToken, fetchRequest, initialFetchListParams } from './index';
const convertDataToServer = bioTreatmentFacility => ({
  ...bioTreatmentFacility,
  sum: convertFromRubToKop(bioTreatmentFacility.sum)
});
const convertDataFromServer = bioTreatmentFacility => ({
  ...bioTreatmentFacility,
  sum: convertFromKopToRub(bioTreatmentFacility.sum)
});
const baseUrl = 'bioTreatmentFacility';
const bioTreatmentFacility = new CommonApi(baseUrl, 'учет БОС', convertDataToServer, convertDataFromServer);
export const changeStatus = async (id, status) => {
  const bioTreatmentFacility = await fetchRequest.put(`/${baseUrl}/changeStatus`, {
    id,
    status
  });
  if (bioTreatmentFacility) return convertDataFromServer(bioTreatmentFacility);
  throw new Error('Не удалось изменит статус');
};
const print = async id => {
  const print = await downloadRequestWithToken(`/${baseUrl}/${id}/print`);
  if (print) return print;
  throw new Error('Не удалось распечатать');
};
export const list = async (params = initialFetchListParams) => {
  const bioTreatmentFacilities = await fetchRequest.get(`/${baseUrl}/list`, {
    ...initialFetchListParams,
    ...params
  });
  if (bioTreatmentFacilities) {
    return {
      ...bioTreatmentFacilities,
      data: bioTreatmentFacilities.data.map(convertDataFromServer)
    };
  }
  throw new Error('Не удалось загрузить список учета БОС');
};
export default {
  ...bioTreatmentFacility,
  print,
  changeStatus,
  list
};
